export default "/images/7cb03888c3a4311e1cb14bf739b08a02.avif";